import { render, staticRenderFns } from "./StackedColumnMulti.vue?vue&type=template&id=bd6e1c84&scoped=true&"
import script from "./StackedColumnMulti.vue?vue&type=script&lang=js&"
export * from "./StackedColumnMulti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd6e1c84",
  null
  
)

export default component.exports